import css from "./ThemeIcons.module.scss";

export const Light = () => {
	return (
		<svg className={css.light} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
			<circle cx="100" cy="100" r="39" />
			<g>
				<line x1="100" y1="22" x2="100" y2="39.83" />
				<line x1="44.85" y1="44.85" x2="57.45" y2="57.45" />
				<line x1="22" y1="100" x2="39.83" y2="100" />
				<line x1="44.85" y1="155.15" x2="57.45" y2="142.55" />
				<line x1="100" y1="178" x2="100" y2="160.17" />
				<line x1="155.15" y1="155.15" x2="142.55" y2="142.55" />
				<line x1="178" y1="100" x2="160.17" y2="100" />
				<line x1="155.15" y1="44.85" x2="142.55" y2="57.45" />
			</g>
		</svg>
	);
};

export const System = () => {
	return (
		<svg className={css.system} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
			<g>
				<line x1="77.78" y1="26.28" x2="77.78" y2="39.03" />
				<line x1="38.34" y1="42.62" x2="47.35" y2="51.63" />
				<line x1="22" y1="82.06" x2="34.75" y2="82.06" />
				<line x1="38.34" y1="121.5" x2="47.35" y2="112.48" />
				<line x1="117.22" y1="42.62" x2="108.2" y2="51.63" />
			</g>
			<path d="M161.96,157.16c-20.06,0-36.33-16.26-36.33-36.33,0-5.76,1.35-11.2,3.73-16.04-12.02,5.92-20.29,18.29-20.29,32.6,0,20.06,16.26,36.33,36.33,36.33,14.3,0,26.67-8.27,32.6-20.29-4.84,2.39-10.28,3.73-16.04,3.73Z" />
			<line x1="33.16" y1="171.3" x2="167.02" y2="37.44" />
			<path d="M101.9,77.65c-2.08-11.45-12.08-20.14-24.13-20.14-13.55,0-24.54,10.99-24.54,24.54,0,12.05,8.69,22.05,20.14,24.13" />
		</svg>
	);
};

export const Dark = () => {
	return (
		<svg className={css.dark} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
			<path d="M135.76,134.76c-38.95,0-70.52-31.57-70.52-70.52,0-11.18,2.61-21.75,7.24-31.14-23.33,11.5-39.38,35.51-39.38,63.28,0,38.95,31.57,70.52,70.52,70.52,27.77,0,51.78-16.06,63.28-39.38-9.39,4.63-19.96,7.24-31.14,7.24Z" />
		</svg>
	);
};
